export default {
    data() {
        return {
            html: ''
        }
    },

    created() {
        this.getInfo();
    },

    methods: {
        getInfo() {
            this.$get('api.php/Index/protocol',{
                type: 5
            }).then(res => {
                this.html = res;
            })
        }
    }
}
